import { useTranslation } from "react-i18next";
import { useJobSearch } from "../../reducers/jobSlice";
import { JobListPanel } from "../ActiveJobPanel";
import { useStatsContext } from "./JobStatsContext";

const JobStatsList = () => {
    const { t } = useTranslation();
    const { search } = useStatsContext();
    const jobs = useJobSearch(search);

    return <JobListPanel jobs={jobs} fixed={true} title={t('job', { count: 100 })}></JobListPanel>
}

export default JobStatsList;